module.exports = __webpack_public_path__ + "img/messages-2.dc9fe2a1.svg";